<script>
	import { fly } from "svelte/transition";
	import { selectedProvider, lang, allProviderDetails } from "../store";
	import { formatCurrency } from "../lib/utils";
	import { TRANSITION_DELAY } from "../constants/constants";

	import ServiceProviderHourInput from "./ServiceProviderHourInput.svelte";

	$: serviceTimes = $selectedProvider?.serviceTimes;

	// Initialize hold state for providers inputs, each providers hour
	// input rows & calculated cost for the row are stored so that the
	// user can switch between providers & compare the calculated costs
	$: if ($selectedProvider?.id && !$allProviderDetails[$selectedProvider.id]) {
		$allProviderDetails[$selectedProvider.id] = {};

		serviceTimes.forEach((t) => {
			if (!$allProviderDetails[$selectedProvider.id][t.day]) {
				$allProviderDetails[$selectedProvider.id][t.day] = {};
			}
			if (!$allProviderDetails[$selectedProvider.id][t.day][t.time]) {
				$allProviderDetails[$selectedProvider.id][t.day][t.time] = {
					hours: 0,
					prices: 0,
				};
			}
		});
	}

	// Update the current providers hours & calculated cost for the given
	// row on input change. Dispatched in ServiceProviderHourInput component
	function addRowInfo(event) {
		const { hours, price, day, time } = event.detail;

		$allProviderDetails[$selectedProvider.id][day][time]["hours"] = hours;
		$allProviderDetails[$selectedProvider.id][day][time]["prices"] = price;
	}
</script>

{#key $selectedProvider?.id}
	{#if serviceTimes}
		<table>
			<thead>
				<tr>
					<td>Ajankohta</td>
					<td>Tuntihinta</td>
					<td>Viikkotunnit</td>
				</tr>
			</thead>
			<tbody>
				{#each serviceTimes as serviceTime, index}
					<tr
						in:fly={{
							y: -10,
							delay: TRANSITION_DELAY * index,
						}}
					>
						<td>{serviceTime.day} klo {serviceTime.time}</td>
						<td>{formatCurrency(serviceTime.price, $lang)}</td>
						<td
							><ServiceProviderHourInput
								{index}
								storedHours={$allProviderDetails[$selectedProvider.id][
									serviceTime.day
								][serviceTime.time]
									? $allProviderDetails[$selectedProvider.id][
											serviceTime.day
									  ][serviceTime.time]["hours"]
									: null}
								price={serviceTime.price}
								day={serviceTime.day}
								time={serviceTime.time}
								on:add-row-info={addRowInfo}
							/></td
						>
					</tr>
				{/each}
			</tbody>
		</table>
	{/if}
{/key}

<style>
	table {
		border-collapse: collapse;
		margin-top: 1rem;
	}

	thead {
		background-color: var(--color-text);
		border-radius: var(--border-radius-small);
	}

	thead td {
		padding: 1rem;
		color: #fff;
	}

	thead td:first-child {
		border-radius: var(--border-radius-small) 0 0 var(--border-radius-small);
		width: 100%;
	}

	thead td:last-child {
		border-radius: 0 var(--border-radius-small) var(--border-radius-small) 0;
	}

	tbody td {
		padding: 0.5rem 1rem;
	}

	tbody tr:not(:last-child) {
		border-bottom: 1px solid #bdbab8;
	}
</style>
